import React from "react";

const PrivateProfiles = () => {
    return (
        <div>
            Private Profiles
        </div>
    );
}

export default PrivateProfiles;